import { useState, type ReactNode } from 'react';
import { assetMeta } from '../../shared/assets-meta';
import { iconUrl } from '../lib/icons';

/**
 * Asset icon: the logo from src/assets/icons/<SYMBOL>.png (fetched by scripts/fetch-icons.mjs, bundled by Vite under a
 * content-hashed same-origin URL, so the CSP needs no third-party image host and a replaced file is never cached stale).
 * A ticker without a file, or a file that fails to load, falls back to a colour-coded monogram, so a newly listed stock
 * is never shown broken. The company logos are trademarks of their owners, used only to identify the stock.
 */
export function AssetIcon({ symbol, size = 32 }: { symbol: string; size?: number }) {
  const [failed, setFailed] = useState(false);
  const { hue } = assetMeta(symbol);
  const src = iconUrl(symbol);
  if (src && !failed) {
    return <img className="asset-icon asset-icon--img" src={src} width={size} height={size} alt="" aria-hidden="true" decoding="async" onError={() => setFailed(true)} />;
  }
  return (
    <span className="asset-icon" aria-hidden="true" style={{ width: size, height: size, fontSize: size * (symbol.length > 3 ? 0.27 : 0.31), background: `oklch(0.42 0.11 ${hue})` }}>
      {symbol === 'USDG' ? '$' : symbol.slice(0, 4)}
    </span>
  );
}

export function AssetName({ symbol, extra, size }: { symbol: string; extra?: ReactNode; size?: number }) {
  return (
    <span className="asset-name">
      <AssetIcon symbol={symbol} size={size} />
      <span className="asset-name__text">
        <span className="asset-name__symbol">{symbol}</span>
        <span className="asset-name__full">{assetMeta(symbol).en}{extra}</span>
      </span>
    </span>
  );
}
